import { render } from "./TrialBalance.vue?vue&type=template&id=6a0f5d8c&ts=true"
import script from "./TrialBalance.vue?vue&type=script&lang=ts"
export * from "./TrialBalance.vue?vue&type=script&lang=ts"

import exportComponent from "/home/muhammadibrahim/Myserver/Pencil_v4_envato/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__